import { Box } from "@repo/components/src/ui/box";
import {
  Checkbox,
  CheckboxIcon,
  CheckboxIndicator,
  CheckboxLabel,
} from "@repo/components/src/ui/checkbox";
import {
  FormControl,
  FormControlError,
  FormControlErrorIcon,
  FormControlErrorText,
  FormControlLabel,
  FormControlLabelText,
} from "@repo/components/src/ui/form-control";
import { AlertCircleIcon, CheckIcon } from "lucide-react-native";
import { Controller, FieldValues } from "react-hook-form";
import { focusScrollRef } from "../focusScrollRef";
import { FormInputProps } from "../types";

export default function FormInputBooleanCheckbox<
  TFieldValues extends FieldValues,
>(
  props: Omit<FormInputProps<TFieldValues, boolean>, "placeholder"> & {
    description: string;
  },
) {
  const {
    control,
    name,
    label,
    required,
    disabled,
    className,
    size,
    labelSize,
    description,
  } = props;
  return (
    <Controller
      name={name}
      control={control}
      disabled={disabled}
      render={({
        field: { onChange, value, name, ref, disabled },
        fieldState: { error },
        formState: { isSubmitting },
      }) => (
        <FormControl
          isInvalid={!!error}
          isRequired={required}
          isDisabled={disabled || isSubmitting}
          className={className}
          size={size}
        >
          {!!label && (
            <FormControlLabel>
              <FormControlLabelText size={labelSize || size}>
                {label}
              </FormControlLabelText>
            </FormControlLabel>
          )}
          <Box ref={focusScrollRef(ref)}>
            <Checkbox
              size={size}
              isChecked={value || false}
              value={name}
              onChange={onChange}
            >
              <CheckboxIndicator>
                <CheckboxIcon as={CheckIcon} />
              </CheckboxIndicator>
              {!!description && <CheckboxLabel>{description}</CheckboxLabel>}
            </Checkbox>
          </Box>
          <FormControlError>
            <FormControlErrorIcon as={AlertCircleIcon} className="mr-1" />
            <FormControlErrorText>{error?.message}</FormControlErrorText>
          </FormControlError>
        </FormControl>
      )}
    />
  );
}
